<template>
    <div class="overview_call">
        <div class="vx-row">
            <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
                <vx-card class="pt-6">
                    <div class="vx-row">
                        <div class="vx-col w-1/4 flex items-center">
                            <div class="icon_call total_call">
                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                     width="25px" height="25px" viewBox="0 0 15 15" version="1.1">
                                    <g id="Page-1" stroke="none" stroke-width="1" fill="#707B90" fill-rule="evenodd">
                                        <g id="Dribbble-Light-Preview" transform="translate(-103.000000, -7321.000000)"
                                           fill="#707B90">
                                            <g id="icons" transform="translate(56.000000, 160.000000)">
                                                <path
                                                    d="M61.7302966,7173.99596 C61.2672966,7175.40296 59.4532966,7176.10496 58.1572966,7175.98796 C56.3872966,7175.82796 54.4612966,7174.88896 52.9992966,7173.85496 C50.8502966,7172.33496 48.8372966,7169.98396 47.6642966,7167.48896 C46.8352966,7165.72596 46.6492966,7163.55796 47.8822966,7161.95096 C48.3382966,7161.35696 48.8312966,7161.03996 49.5722966,7161.00296 C50.6002966,7160.95296 50.7442966,7161.54096 51.0972966,7162.45696 C51.3602966,7163.14196 51.7112966,7163.84096 51.9072966,7164.55096 C52.2742966,7165.87596 50.9912966,7165.93096 50.8292966,7167.01396 C50.7282966,7167.69696 51.5562966,7168.61296 51.9302966,7169.09996 C52.6632966,7170.05396 53.5442966,7170.87696 54.5382966,7171.50296 C55.1072966,7171.86196 56.0262966,7172.50896 56.6782966,7172.15196 C57.6822966,7171.60196 57.5872966,7169.90896 58.9912966,7170.48196 C59.7182966,7170.77796 60.4222966,7171.20496 61.1162966,7171.57896 C62.1892966,7172.15596 62.1392966,7172.75396 61.7302966,7173.99596 C61.4242966,7174.92396 62.0362966,7173.06796 61.7302966,7173.99596"
                                                    id="call-[#192]">
                                                </path>
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                            </div>
                        </div>
                        <div class="vx-col w-3/4">
                            <h3 class="">Tổng cuộc gọi</h3>
                            <h1 class="mt-4" style="color: #707B90">{{ totalCallCount }}</h1>
                        </div>
                    </div>
                </vx-card>
            </div>
            <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
                <vx-card class="pt-6">
                    <div class="vx-row">
                        <div class="vx-col w-1/4 flex items-center">
                            <div class="icon_call imcoming_call">
                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                     width="30px" height="30px" viewBox="0 0 20 20" version="1.1">

                                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                        <g id="Dribbble-Light-Preview" transform="translate(-180.000000, -7319.000000)"
                                           fill="#387CFB">
                                            <g id="icons" transform="translate(56.000000, 160.000000)">
                                                <path
                                                    d="M142.8193,7165.2034 L140.4173,7165.1794 C139.9723,7165.1794 139.7613,7164.6534 140.0763,7164.3384 L143.7073,7160.7074 C144.0973,7160.3164 144.0973,7159.6834 143.7073,7159.2934 C143.3163,7158.9024 142.6833,7158.9024 142.2933,7159.2934 L138.6603,7162.9254 C138.3453,7163.2404 137.7943,7163.0044 137.7953,7162.5594 L137.7893,7160.1734 C137.7893,7159.6214 137.3203,7159.1524 136.7673,7159.1524 C136.2153,7159.1524 135.7763,7159.6074 135.7763,7160.1604 L135.7803,7165.1664 C135.7803,7166.2694 136.6783,7167.1674 137.7823,7167.1674 C138.5613,7167.1724 137.7333,7167.1704 142.7913,7167.1764 C143.3443,7167.1764 143.8013,7166.7374 143.8013,7166.1854 C143.8013,7165.6324 143.3713,7165.2034 142.8193,7165.2034 M138.1163,7174.5784 C137.4223,7174.2044 136.7183,7173.7774 135.9913,7173.4814 C134.5873,7172.9084 134.6823,7174.6014 133.6783,7175.1514 C132.2543,7175.9314 127.6203,7171.4154 127.8293,7170.0144 C127.9913,7168.9304 129.2743,7168.8754 128.9073,7167.5504 C128.7113,7166.8404 128.3603,7166.1414 128.0973,7165.4574 C127.7443,7164.5404 127.6003,7163.9524 126.5723,7164.0034 C125.8313,7164.0394 125.3383,7164.3564 124.8823,7164.9504 C123.6493,7166.5574 123.8353,7168.7254 124.6643,7170.4884 C126.9923,7175.4384 131.7423,7178.6794 135.1573,7178.9874 C136.4533,7179.1044 138.2663,7178.4024 138.7303,7176.9964 C138.6983,7177.0944 138.6663,7177.1884 138.6513,7177.2344 C138.6633,7177.1984 138.6873,7177.1274 138.7303,7176.9954 C138.7773,7176.8544 138.8003,7176.7824 138.8113,7176.7514 C138.7973,7176.7924 138.7653,7176.8904 138.7313,7176.9924 C139.1393,7175.7524 139.1883,7175.1554 138.1163,7174.5784 M138.6513,7177.2344 C138.6393,7177.2704 138.6413,7177.2654 138.6513,7177.2344 M138.8113,7176.7514 C138.8183,7176.7274 138.8193,7176.7254 138.8113,7176.7514"
                                                    id="call-[#190]">
                                                </path>
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                            </div>
                        </div>
                        <div class="vx-col w-3/4">
                            <h3>Cuộc gọi đến</h3>
                            <h1 class="mt-4" style="color: #387CFB">{{ imcomingCallCount }}</h1>
                        </div>
                    </div>
                </vx-card>
            </div>
            <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
                <vx-card class="pt-6">
                    <div class="vx-row">
                        <div class="vx-col w-1/4 flex items-center">
                            <div class="icon_call outgoing_call">
                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                     width="30px" height="30px" viewBox="0 0 20 20" version="1.1">
                                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                        <g id="Dribbble-Light-Preview" transform="translate(-220.000000, -7319.000000)"
                                           fill="#1CAB4E">
                                            <g id="icons" transform="translate(56.000000, 160.000000)">
                                                <path
                                                    d="M183.9954,7161.01 C183.9954,7159.906 183.0974,7159.008 181.9934,7159.008 C181.2144,7159.003 182.0424,7159.006 176.9844,7159 C176.4324,7159 175.9744,7159.439 175.9754,7159.991 C175.9754,7160.543 176.4044,7160.973 176.9564,7160.973 L179.3584,7160.997 C179.8044,7160.997 180.0144,7161.523 179.6994,7161.838 L176.0684,7165.469 C175.6784,7165.86 175.6784,7166.493 176.0684,7166.883 C176.4594,7167.274 177.0924,7167.274 177.4834,7166.883 L181.1154,7163.251 C181.4304,7162.936 181.9814,7163.172 181.9814,7163.617 L181.9864,7166.003 C181.9864,7166.555 182.4554,7167.024 183.0084,7167.024 C183.5604,7167.024 184.0004,7166.568 184.0004,7166.016 L183.9954,7161.01 Z M178.1164,7174.578 C177.4214,7174.204 176.7184,7173.778 175.9914,7173.481 C174.5874,7172.908 174.6824,7174.602 173.6784,7175.151 C173.0264,7175.508 172.1074,7174.861 171.5384,7174.503 C170.5444,7173.877 169.6634,7173.053 168.9304,7172.1 C168.5564,7171.613 167.7274,7170.697 167.8294,7170.014 C167.9914,7168.93 169.2744,7168.876 168.9074,7167.55 C168.7114,7166.84 168.3604,7166.141 168.0974,7165.457 C167.7444,7164.54 167.6004,7163.953 166.5724,7164.003 C165.8314,7164.039 165.3384,7164.356 164.8824,7164.951 C163.6494,7166.558 163.8354,7168.725 164.6644,7170.488 C165.8374,7172.983 167.8494,7175.335 169.9994,7176.855 C171.4614,7177.889 173.3874,7178.828 175.1574,7178.987 C176.4534,7179.104 178.2664,7178.403 178.7304,7176.996 C178.6974,7177.094 178.6664,7177.189 178.6514,7177.234 C178.6634,7177.199 178.6864,7177.128 178.7304,7176.996 C178.7764,7176.854 178.8004,7176.783 178.8104,7176.751 C178.7974,7176.793 178.7644,7176.891 178.7314,7176.993 C179.1394,7175.752 179.1884,7175.155 178.1164,7174.578 L178.1164,7174.578 Z M178.6514,7177.234 C178.6414,7177.265 178.6394,7177.27 178.6514,7177.234 L178.6514,7177.234 Z M178.8104,7176.751 C178.8184,7176.727 178.8194,7176.725 178.8104,7176.751 L178.8104,7176.751 Z"
                                                    id="call-[#189]">
                                                </path>
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                            </div>
                        </div>
                        <div class="vx-col w-3/4">
                            <h3>Cuộc gọi đi</h3>
                            <h1 class="mt-4" style="color: #1CAB4E">{{ outgoingCallCount }}</h1>
                        </div>
                    </div>
                </vx-card>
            </div>
            <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
                <vx-card class="pt-6">
                    <div class="vx-row">
                        <div class="vx-col w-1/4 flex items-center">
                            <div class="icon_call miss_call">
                                <svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" viewBox="0 0 16 16">
                                    <path
                                        d="m 12.980469 -0.0117188 c -0.039063 0.0039063 -0.074219 0.00781255 -0.113281 0.0117188 h -4.867188 v 0.832031 c -0.050781 0.292969 0.03125 0.59375 0.226562 0.820313 c 0.191407 0.222656 0.476563 0.351562 0.773438 0.347656 h 1.585938 l -2.585938 2.585938 l -2.292969 -2.292969 c -0.25 -0.261719 -0.625 -0.367188 -0.972656 -0.273438 c -0.351563 0.089844 -0.625 0.363281 -0.714844 0.714844 c -0.09375 0.347656 0.011719 0.722656 0.273438 0.972656 l 3 3 c 0.390625 0.390625 1.023437 0.390625 1.414062 0 l 3.292969 -3.292969 v 1.585938 c -0.003906 0.296875 0.125 0.578125 0.347656 0.769531 c 0.222656 0.191407 0.519532 0.277344 0.808594 0.230469 h 0.84375 v -4.875 c 0.011719 -0.089844 0.011719 -0.183594 0 -0.273438 v -0.851562 h -0.855469 c -0.054687 -0.0078125 -0.109375 -0.0117188 -0.164062 -0.0117188 z m 0 0"
                                        fill="#e01b24"/>
                                    <path class="error"
                                          d="m 14.242188 15.714844 c -0.386719 0.382812 -1.003907 0.382812 -1.386719 0 l -1.042969 -1.039063 l -1.039062 -1.042969 c -0.382813 -0.382812 -0.382813 -1 0 -1.386718 l 0.492187 -0.492188 c -2.035156 -1.109375 -4.496094 -1.109375 -6.53125 0 l 0.492187 0.492188 c 0.382813 0.386718 0.382813 1.003906 0 1.386718 l -1.039062 1.042969 l -1.042969 1.039063 c -0.382812 0.382812 -1 0.382812 -1.386719 0 l -1.039062 -1.039063 c -0.957031 -0.957031 -0.957031 -2.511719 0 -3.46875 l 0.347656 -0.347656 c 3.816406 -3.816406 10.050782 -3.816406 13.867188 0 l 0.347656 0.347656 c 0.957031 0.957031 0.957031 2.511719 0 3.46875 z m 0 0"
                                          fill="#e01b24"/>
                                </svg>
                            </div>
                        </div>
                        <div class="vx-col w-3/4">
                            <h3>Cuộc gọi nhỡ</h3>
                            <h1 class="mt-4" style="color: #e01b24">{{ missCallCount }}</h1>
                        </div>
                    </div>
                </vx-card>
            </div>
        </div>
        <div class="vx-row mt-6 match-height">
            <div class="vx-col md:w-2/3 w-full">
                <vx-card class="pt-6">
                    <vue-apex-charts ref="chartCall" type="line" height="350" :options="dataChartLine.chartOptions"
                                     :series="dataChartLine.series"></vue-apex-charts>
                </vx-card>
            </div>
            <div class="vx-col md:w-1/3 w-full">
                <vx-card class="pt-6">
                    <vue-apex-charts type="pie" height="380" :options="dataChartPie.chartOptions"
                                     :series="dataChartPie.series"></vue-apex-charts>
                </vx-card>
            </div>
        </div>
    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';

export default {
    name: "Overview",
    components: {
        VueApexCharts,
    },
    data() {
        return {
            totalCallCount: 0,
            imcomingCallCount: 0,
            outgoingCallCount: 0,
            missCallCount: 0,
            dataChartLine: {
                series: [],
                chartOptions: {
                    chart: {
                        height: 350,
                        type: 'line',
                        dropShadow: {
                            enabled: true,
                            color: '#000',
                            top: 18,
                            left: 7,
                            blur: 10,
                            opacity: 0.2
                        },
                        toolbar: {
                            show: false
                        }
                    },
                    colors: ['#387CFB', '#1CAB4E', '#D63443'],
                    dataLabels: {
                        enabled: true,
                    },
                    stroke: {
                        curve: 'smooth'
                    },
                    title: {
                        text: 'Biểu đồ cuộc gọi trong ngày',
                        align: 'left',
                        style: {
                            fontSize: '16px',
                            fontWeight: 'bold',
                            fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
                            color: '#263238'
                        },
                    },
                    markers: {
                        size: 2
                    },
                    xaxis: {
                        categories: [],
                        title: {
                            text: 'Giờ',
                            style: {
                                fontSize: '16px',
                                fontWeight: 'bold',
                                fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
                                color: '#263238'
                            },
                        }
                    },
                    legend: {
                        position: 'top',
                        horizontalAlign: 'right',
                        floating: true,
                        offsetY: -25,
                        offsetX: -5
                    }
                },
            },
            dataChartPie: {
                series: [],
                chartOptions: {
                    chart: {
                        width: 380,
                        type: 'pie',
                    },
                    labels: ['Cuộc gọi đến', 'Cuộc gọi đi', 'Cuộc gọi nhỡ'],
                    responsive: [{
                        breakpoint: 480,
                        options: {
                            chart: {
                                width: 200
                            },
                            legend: {
                                position: 'bottom'
                            }
                        }
                    }],
                    colors: ['#387CFB', '#1CAB4E', '#D63443'],
                    title: {
                        text: 'Biểu đồ cuộc gọi trong ngày',
                        align: 'left',
                        style: {
                            fontSize: '16px',
                            fontWeight: 'bold',
                            fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
                            color: '#263238'
                        },
                    },
                },
            }
        }
    },

    async created() {
        this.$vs.loading();
        await Promise.all([this.getTotalCall(), this.getIncomingCall(), this.getOutGoingCall(), this.getMissCall(), this.getDataChartLine(), this.getDataChartPie()])
        // await this.getTotalCall();
        // await this.getIncomingCall();
        // await this.getOutGoingCall();
        // await this.getMissCall();
        // await this.getDataChart();
        this.$vs.loading.close();
    },

    methods: {
        getTotalCall() {
            this.$crm.get('/ott/vbot/count-total-call').then(res => {
                this.totalCallCount = res.data;
            }).catch((err) => {
                return this.$vs.notify({
                    title: 'Error',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        getIncomingCall() {
            this.$crm.get('/ott/vbot/count-total-in-call').then(res => {
                this.imcomingCallCount = res.data;
            }).catch((err) => {
                return this.$vs.notify({
                    title: 'Error',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        getOutGoingCall() {
            this.$crm.get('/ott/vbot/count-total-out-call').then(res => {
                this.outgoingCallCount = res.data;
            }).catch((err) => {
                return this.$vs.notify({
                    title: 'Error',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        getMissCall() {
            this.$crm.get('/ott/vbot/count-total-miss-call').then(res => {
                this.missCallCount = res.data;
            }).catch((err) => {
                return this.$vs.notify({
                    title: 'Error',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        getDataChartLine() {
            this.$crm.get('/ott/vbot/get-call-history-summarize-chart').then(res => {
                this.dataChartLine.chartOptions.xaxis.categories = [];
                this.dataChartLine.series = [];
                if (res.data) {
                    let hour = new Date().getHours()

                    let seriesInCall = [],
                        seriesOutCall = [],
                        seriesMissCall = [];

                    res.data.inCall.filter(el => el.hour <= hour + 1).forEach(el => {
                        seriesInCall.push(el.totalCall);
                    })
                    res.data.outCall.filter(el => el.hour <= hour + 1).forEach(el => {
                        seriesOutCall.push(el.totalCall);
                    })
                    res.data.missCall.filter(el => el.hour <= hour + 1).forEach(el => {
                        seriesMissCall.push(el.totalCall);
                    })
                    this.dataChartLine.series = [
                        {
                            name: 'Cuộc gọi đến',
                            data: seriesInCall
                        },
                        {
                            name: 'Cuộc gọi đi',
                            data: seriesOutCall
                        },
                        {
                            name: 'Cuộc gọi nhỡ',
                            data: seriesMissCall
                        },
                    ]

                    this.$refs.chartCall.updateOptions({
                        xaxis: {
                            categories: res.data.totalCall.map(el => el.hour <= hour + 1 && el.hour.toString())
                        }
                    })
                }
            }).catch((err) => {
                return this.$vs.notify({
                    title: 'Error',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        getDataChartPie() {
            this.dataChartPie.series = [];
            this.$crm.get('/ott/vbot/get-call-history-percentage-chart').then(res => {
                this.dataChartPie.series.push(res.data.inCallPercentage, res.data.outCallPercentage, res.data.missCallPercentage)
            }).catch((err) => {
                return this.$vs.notify({
                    title: 'Error',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        }
    }
}
</script>

<style scoped>
.icon_call {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    width: 50px;
    height: 50px;
}

.total_call {
    background-color: #ecedf0 !important;
}

.imcoming_call {
    background-color: #387cff12 !important;
}

.outgoing_call {
    background-color: #1cab4e40 !important;
}

.miss_call {
    background-color: #d6344336 !important;
}
</style>
